import type { Listing } from '@thevillages/schemas';

import { Component, input } from '@angular/core';

@Component({
  imports: [],
  selector: 'app-home-listing-card-open-house',
  styleUrl: './open-house.css',
  templateUrl: './open-house.html',
})
export class HomeListingCardOpenHouse {
  public readonly listing = input.required<Listing>();
  public readonly openNow = input.required<boolean>();
}
